import { SelectableEntity } from '../model/entity/selectable-entity';
import { SortableList } from '../model/sortable-list';
import { StandardAction } from '../tool/action/standard-action';

export class SortableListBuilder<T extends SelectableEntity> {
  private readonly sortableList: SortableList<T>;

  constructor(id: string, title: string, items: T[] = []) {
    this.sortableList = new SortableList<T>(id, title, items);
  }

  public setItems(items: T[]): SortableListBuilder<T> {
    this.sortableList.items = items;
    return this;
  }

  public addAction(action: StandardAction): SortableListBuilder<T> {
    this.sortableList.actions.push(action);
    return this;
  }

  public addActions(actions: StandardAction[]): SortableListBuilder<T> {
    this.sortableList.actions = [...this.sortableList.actions, ...actions];
    return this;
  }

  public setIcon(icon: string): SortableListBuilder<T> {
    this.sortableList.icon = icon;
    return this;
  }

  public enabled(): SortableListBuilder<T> {
    this.sortableList.disabled = false;
    return this;
  }

  public disabled(): SortableListBuilder<T> {
    this.sortableList.disabled = true;
    return this;
  }

  public setDisabled(disabled: boolean): SortableListBuilder<T> {
    this.sortableList.disabled = disabled;
    return this;
  }

  public setVisible(visible: boolean): SortableListBuilder<T> {
    this.sortableList.visible = visible;
    return this;
  }

  public setMinWidth(minWidth: string): SortableListBuilder<T> {
    this.sortableList.minWidth = minWidth;
    return this;
  }

  public setMaxWidth(maxWidth: string): SortableListBuilder<T> {
    this.sortableList.maxWidth = maxWidth;
    return this;
  }

  public setBorderColor(borderColor: string): SortableListBuilder<T> {
    this.sortableList.borderColor = borderColor;
    return this;
  }

  public build(): SortableList<T> {
    return this.sortableList;
  }
}
